import api from "./api/api";
import TokenService from "./api/token";

class UserAdminService { 
    // Get users with pagination, sorting and filtering
    getUsers(params = {}) {
      const {
        page = 1,
        per_page = 50,
        search = '',
        sort_by = 'firstname',
        sort_dir = 'asc',
        filter = 'all'
      } = params;

      const queryParams = new URLSearchParams({
        page: page.toString(),
        per_page: per_page.toString(),
        search,
        sort_by,
        sort_dir,
        filter
      });

      return api.get(`/admin/users/list/?${queryParams}`);
    }

    addUser(user) {
      return api.post("/admin/users/add/", user);
    }

    deleteUser(id) {
      return api.delete("/admin/users/delete/" + id + "/");
    }

    // Import users from spreadsheet rows. With dryRun nothing is saved.
    uploadExcel(rows, dryRun) {
      return api.post("/admin/users/upload/users/", {
        users: rows,
        dry_run: !!dryRun,
      });
    }

    uploadExcelInvites(id, rows) {
      return api.post("/admin/users/upload/invites/", {
        meeting_id: id,
        invites: rows,
      });
    }

    // Import one building file into a meeting: creates missing users and
    // invites every e-mail address once. With dryRun nothing is saved.
    importMeetingFile(id, rows, dryRun) {
      return api.post("/admin/users/upload/meeting/", {
        meeting_id: id,
        rows: rows,
        dry_run: !!dryRun,
      });
    }

    updateMail(id, mail) {
      return api.post("/admin/users/update/mail/", {
        id: id,
        mail: mail,
      });
    }

}

export default new UserAdminService();